import { Component, Inject, OnDestroy, type OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { PageOptions, ParameterProvider, RoleListProvider } from "cw-backend";
import { CwUtils, SnackBarService } from "cw-utils";
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from "rxjs";
import { ChatPanelService } from "../chat-panel/chat-panel.service";
import { RequireMatch } from "app/validators/requireMatch";
import { ParameterInsert } from "../../../../../shared/cw-backend/models/register/organizational/parameter-insert";
import { ParameterNameEnum } from "../../../../../shared/cw-backend/models/application/parameter/parameter-name-enum.enum";
import { log } from "console";

@Component({
    selector: "app-dialog-message",
    templateUrl: "./dialog-message.component.html",
    styleUrls: ["./dialog-message.component.scss"],
})
export class DialogMessageComponent implements OnInit, OnDestroy {
    pageOptions = new PageOptions();
    messageControl = new FormControl("");
    roleControl = new FormControl("", [
        Validators.required,
        RequireMatch.bind(this),
    ]);
    professionalId: number | null = null;
    roleList = new Array<any>();

    roleDefault: any;
    isSending = false;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        public _matDialogRef: MatDialogRef<DialogMessageComponent>,
        private snackBar: SnackBarService,
        private roleListProvider: RoleListProvider,
        private _chatPanelService: ChatPanelService,
        private parameterProvider: ParameterProvider,
        @Inject(MAT_DIALOG_DATA) private _data: any
    ) {}

    ngOnInit(): void {
        this.professionalId = this._data?.professionalId ?? null;
        this.roleDefault = this.professionalId != null
            ? JSON.parse(sessionStorage.getItem(ParameterNameEnum.DEFAULT_ROLE_MESSAGE) || 'null')
            : null;
        this.messageControl.setValue(this.professionalId != null ? this._data?.message || '' : '');
        this.getRoleList();
        this.ObservableRole();
        this.getRoleDefault();
    }

    ngOnDestroy() {
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    getRoleList() {
        this.roleListProvider
            .getRoleSimpleListDto(this.pageOptions)
            .then((res) => {
                this.roleList = res.body.content;
            });
    }

    getRoleid(roleId) {
        this.roleListProvider.getRoleById(roleId).then((res) => {
            this.roleControl.setValue(res.body, { emitEvent: false });
            sessionStorage.setItem(
                ParameterNameEnum.DEFAULT_ROLE_MESSAGE,
               JSON.stringify(res.body)
            );
        });
    }

    getRoleDefault() {
        if (this.professionalId == null) {
            return;
        }

        if(this.roleDefault?.id){
            this.roleControl.setValue(this.roleDefault, { emitEvent: false });
            return
        }
        this.parameterProvider
            .getParameterValueByKeyAndName(
                String(this.professionalId),
                ParameterNameEnum.DEFAULT_ROLE_MESSAGE
            )
            .then((res) => {
                if (CwUtils.checkStringIsNotNull(res.body?.value)) {
                    this.getRoleid(res.body?.value);
                }
            });
    }

    setRoleDefault() {
        if (!this.roleControl.value?.id) {
            this.snackBar.warnMessage("Grupo inválido!");
            this.roleControl.markAsTouched();
            return;
        }

        if (this.professionalId == null || this.professionalId == undefined) {
            this.snackBar.warnMessage("profissional inválido tente novamente");
            return;
        }
        this.insertParameter();
    }

    insertParameter() {
        let parameterInser = new ParameterInsert();
        parameterInser.name = ParameterNameEnum.DEFAULT_ROLE_MESSAGE;
        parameterInser.key = String(this.professionalId);
        parameterInser.value = this.roleControl.value?.id;

        this.parameterProvider
            .insertParameterValue(parameterInser)
            .then((res) => {
                sessionStorage.setItem(
                    ParameterNameEnum.DEFAULT_ROLE_MESSAGE,
                    JSON.stringify(this.roleControl.value)
                );
            });
    }

    sendMessage() {
        if (this.isSending) {
            return;
        }

        if (!this.roleControl.value?.id) {
            this.snackBar.warnMessage("Grupo inválido!");
            this.roleControl.markAsTouched();
            return;
        }

        this.isSending = true;
        this._chatPanelService
            .sendMessageByRoleId(
                this.roleControl.value.id,
                this.messageControl.value
            )
            .then((res) => {
                this.snackBar.successMessage("Mensagem enviado");
                this.dimiss();
            }, () => {
                this.isSending = false;
            });
    }

    ObservableRole() {
        this.roleControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                let filter = "";
                if (typeof res == "string") {
                    filter = res;
                }

                this.pageOptions.argument = filter;
                this.getRoleList();
            });
    }
    dimiss() {
        this._matDialogRef.close();
    }

    displaySimpleFn(object?: any): string | undefined {
        if (object && object.name) {
            return object.name;
        } else {
            return "";
        }
    }
}
